export default "__VITE_ASSET__Cq0ZueA___"